const getCustomerId = (customerData) => {
  let { CustomerId: customerId, 'Customer Id': fallbackCustomerId } =
    customerData;
  if (customerId === undefined && fallbackCustomerId === undefined) {
    return;
  } else if (customerId === undefined) {
    customerId = fallbackCustomerId;
  }
  return customerId;
};

const isCustomerValid = (customerData) => {
  const customerId = getCustomerId(customerData);
  return typeof customerId === 'string';
};

const getCovFromCustomerData = (customerData) => {
  const customerId = getCustomerId(customerData);
  customerData['Customer ID'] = customerId;
  const { DvCustomerName: name, Dvcustomername: fallbackName } = customerData;
  if (typeof name !== 'string' && typeof fallbackName === 'string') {
    customerData['DvCustomerName'] = fallbackName;
  }
  const { Sentimeter: sentimeter, 'KPI SENTIMETER Value': fallbackSentimeter } =
    customerData;
  if (
    typeof sentimeter !== 'string' &&
    typeof fallbackSentimeter === 'string'
  ) {
    customerData['Sentimeter'] = fallbackSentimeter;
    customerData['Kpi Sentimeter Value'] = fallbackSentimeter;
  }
  Object.keys(customerData).forEach((key) => {
    if (customerData[key] === 'Null') {
      delete customerData[key];
    }
  });
  const cov = {
    'Household ID': null,
    Main: customerId,
    Household: {
      [customerId]: {
        correlationDetails: [],
        customerKpiDetails: [],
        customerPredictionDetails: [],
        eventDetails: [],
        householdKpiDetails: [],
        householdPredictionDetails: [],
        relationshipDetails: [],
        relationshipKpiDetails: [],
        relationshipPredictionDetails: [],
        customerDetails: customerData,
      },
    },
  };
  return cov;
};

export { getCovFromCustomerData, isCustomerValid };
